import Vue from 'vue'
import { jiminnyHost } from '@/helpers/region'
import store from '@/store'
import ActivityNotesPlugin from 'vue-components/activity-notes'

Vue.use(ActivityNotesPlugin, {
  store,
  jiminnyHost,
  theme: 'extension'
})



// WEBPACK FOOTER //
// ./src/plugins/activity-notes.js